export enum CommentingUserEventTypes {
  ResolveAllThreads = 'Comments - resolve all',
  DeleteAllResolved = 'Comments - delete all',
  ResolveThread = 'Comments - resolve and hide',
  EditThread = 'Comments - edit',
  DeleteThread = 'Comments - delete comment',
  DeleteResolvedThread = 'Comments - delete chat',
  ActivateThread = 'Comments - set active',
  CreateThread = 'Comments - add comment',
  CreateReply = 'Comments - reply',
  FilterToActiveThreads = 'Comments - active',
  FilterToMentionedThreads = 'Comments - mentioned',
  FilterToVisibleForAuditorThreads = 'Comments - visible for auditor',
  FilterToResolvedThreads = 'Comments - resolved',
  DisplaySingleThread = 'Comments - display single thread',
  CloseSingleThreadDisplay = 'Comments - close single thread display',
  FocusThread = 'Comments - open chat',
  OpenSidebarViaCTA = 'Comments - open sidebar',
}

export enum CommentingEventDataProperty {
  numberOfOpenChats = '# open chats',
  numberOfChats = '# of chats',
  numberOfComments = '# of comments',
  numberOfRepliesBefore = 'number of replies before',
  mentioned = 'mentioned'
}

export type CommentingEventData = {
  [CommentingEventDataProperty.numberOfOpenChats]: number;
  [CommentingEventDataProperty.mentioned]: 'yes' | 'no';
};
